/* Employee Options Screen Component */
import React from "react";
import { useNavigate } from "react-router";

import '../css/calendar.css';
import '../css/common.css';
import '../css/dashboard.css';
import '../css/employee-portal.css';
import '../css/kiosk.css';
import { getAppLocation } from "../utils/storage";



const EmployeeOptionsScreen = () => {
  const location = getAppLocation();
  const nav = useNavigate();
  return (
    <div className="options-screen">
      <button className="back-button" onClick={() => nav('/')}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back
      </button>
      
      <h2 className="options-title">Employee Options</h2>
      <p className="options-subtitle">Please select the appropriate option for your situation.</p>
      <br />
      
      <div className="options-container">
        
        <div 
          className="option-button no-tap-highlight" 
          onClick={() => nav('main-office-sign-out')}
        >
          <div className="option-icon">🏢</div>
          <div className="option-label">Main Office Sign Out</div>
          <div className="option-description">I'm leaving {location} </div>
        </div>
        
        <div 
          className="option-button no-tap-highlight" 
          onClick={() => nav('visiting-office-sign-in')}
        >
          <div className="option-icon">🚗</div>
          <div className="option-label"> Office Sign In</div>
          <div className="option-description">I'm visiting this location from another Magni office or I am signing back in.</div>
        </div>
        <div 
          className="option-button no-tap-highlight" 
          onClick={() => nav('visiting-office-sign-out')}
        >
          <div className="option-icon">👋</div>
          <div className="option-label">Vistor Office Sign Out</div>
          <div className="option-description">I'm signing out from this location</div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeOptionsScreen;

